// Hook para editar paciente (UPDATE directo bajo RLS pacientes_update_kine).
// No usa RPC — el UPDATE estándar es más simple y RLS cubre la seguridad
// (solo el kine dueño puede modificar).

import { useState } from "react";
import { supabase } from "../client";
import type { PatientFormEditData } from "@/app/components/patients/PatientFormDialog";

export interface UseEditarPacienteReturn {
  editar: (pacienteId: string, data: PatientFormEditData) => Promise<boolean>;
  loading: boolean;
  error: string | null;
  reset: () => void;
}

export function useEditarPaciente(): UseEditarPacienteReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function editar(
    pacienteId: string,
    data: PatientFormEditData,
  ): Promise<boolean> {
    setLoading(true);
    setError(null);
    try {
      const { error: updateError } = await supabase
        .from("pacientes")
        .update({
          nombre: data.nombre,
          apellido: data.apellido,
          email: data.email,
          telefono: data.telefono,
          fecha_nacimiento: data.fecha_nacimiento,
          notas_clinicas: data.notas_clinicas,
          updated_at: new Date().toISOString(),
        })
        .eq("id", pacienteId);

      if (updateError) {
        console.warn("[useEditarPaciente] update error", updateError);
        setError(updateError.message);
        return false;
      }
      return true;
    } catch (e) {
      const msg = e instanceof Error ? e.message : String(e);
      console.error("[useEditarPaciente] failed", e);
      setError(msg);
      return false;
    } finally {
      setLoading(false);
    }
  }

  return { editar, loading, error, reset: () => setError(null) };
}
